

import React, { memo } from 'react';

import cx from 'classnames';
import { Image } from '../../../../Image';
import Text from '../../../../Text';
import { USER_DETAILS_CONTAINER, CONTAINER } from '../styles/userDetails';







const UserDetail = ({ userName, profileImage, children }) =>
<div className={cx('user-details__container', USER_DETAILS_CONTAINER)}>
    <Image
    imageUrl={profileImage}
    placeholderText={userName}
    placeholderTextSize={13}
    width="40px"
    height="40px"
    defaultImageIcon="user-profile-sq"
    circular />

    <div className={cx('user-details__name-container', CONTAINER)}>
      {
    userName && !userName.includes('undefined') ?
    <Text highlighted noMargin>{userName}</Text> :
    null}

      {children}
    </div>

  </div>;


export default memo(UserDetail);